import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { TranslationLoaderService } from "src/app/core/service/translation-loader.service";
import { locale as english } from "./i18n/en-US";
import { locale as spanish } from "./i18n/es-ES";
import { locale as portuguese } from "./i18n/pt-BR";

export interface ConfirmDialogData {
    title: string;
    msg: string;
    mandatoryConfirmationPhrase?: boolean;
    customizeConfirmationPhrase?: string;
    type?: ActionsTypes;
}

export enum ActionsTypes {
    cancel_accept = "cancel_accept",
    onlyOk = "onlyOk",
    knowMore = "knowMore",
    yes_no = "yes_no"
}

@Component({
    selector: "app-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"]
})
export class ConfirmDialogComponent implements OnInit {
    public confirmation: string;
    public confirmationPhrase: string;
    public type: ActionsTypes;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        private _translationLoaderService: TranslationLoaderService,
        private translateService: TranslateService
    ) {
        if (data.mandatoryConfirmationPhrase == null) data.mandatoryConfirmationPhrase = true;
        this._translationLoaderService.loadTranslations(english, portuguese, spanish);

        this.type = data.type ?? ActionsTypes.cancel_accept;

        this.translateService
            .get("DIALOG.CONFIRMATION")
            .subscribe((msg) => (this.confirmationPhrase = data.customizeConfirmationPhrase ?? msg));
    }

    ngOnInit(): void {}

    checkConfirmation(): boolean {
        if (this.confirmationPhrase == this.confirmation) return true;
        else false;
    }
}
